document.addEventListener('DOMContentLoaded', function () {
  var countdowns = document.querySelectorAll('[data-yoko-countdown]');

  countdowns.forEach(function (box) {
    var end = parseInt(box.getAttribute('data-end'), 10);
    var timeNode = box.querySelector('.yoko-coupon-card__timer-time');

    if (!end || !timeNode) return;

    function pad(num) {
      return String(num).padStart(2, '0');
    }

    function updateCountdown() {
      var now = Math.floor(Date.now() / 1000);
      var diff = end - now;

      if (diff <= 0) {
        timeNode.textContent = '00:00:00';
        box.classList.add('is-ended');
        return;
      }

      var hours = Math.floor(diff / 3600);
      var minutes = Math.floor((diff % 3600) / 60);
      var seconds = diff % 60;

      timeNode.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });

  var copyButtons = document.querySelectorAll('[data-yoko-copy-code]');

  copyButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var code = button.getAttribute('data-code');
      var defaultLabel = button.getAttribute('data-label-default') || 'Kopēt kodu';
      var copiedLabel = button.getAttribute('data-label-copied') || 'Kods nokopēts';

      if (!code) return;

      function showCopiedState() {
        button.textContent = copiedLabel;
        button.classList.add('is-copied');

        setTimeout(function () {
          button.textContent = defaultLabel;
          button.classList.remove('is-copied');
        }, 1800);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopiedState).catch(function () {
          fallbackCopy(code, showCopiedState);
        });
      } else {
        fallbackCopy(code, showCopiedState);
      }
    });
  });

  function fallbackCopy(text, callback) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';

    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      callback();
    } catch (error) {
      console.warn('Coupon code copy failed', error);
    }

    document.body.removeChild(textarea);
  }
});